/**
 * Single brand theme for VLSI Expert Pvt. Ltd.
 * Navy primary + amber accent (aligned with product favicon).
 */
const vlsiColors = {
  primary: {
    50: '#eef4fb',
    100: '#d9e6f5',
    200: '#b4cce9',
    300: '#86a9d6',
    400: '#5784bf',
    500: '#1e4d8c',
    600: '#163a6b',
    700: '#122f57',
    800: '#0e2443',
    900: '#0a1830',
  },
  secondary: {
    50: '#f4f6f8',
    100: '#e8ecf1',
    200: '#d0d8e2',
    300: '#b0bdcc',
    400: '#8799af',
    500: '#64748b',
    600: '#4b5c70',
    700: '#3a4758',
    800: '#273040',
    900: '#161c26',
  },
  accent: {
    50: '#fff8eb',
    100: '#feefc7',
    200: '#fde68a',
    300: '#fcd34d',
    400: '#fbbf24',
    500: '#d97706',
    600: '#b45309',
    700: '#92400e',
    800: '#78350f',
    900: '#5c280c',
  },
  success: {
    50: '#f0fdf4',
    100: '#dcfce7',
    200: '#bbf7d0',
    300: '#86efac',
    400: '#4ade80',
    500: '#16a34a',
    600: '#15803d',
    700: '#166534',
    800: '#14532d',
    900: '#052e16',
  },
  warning: {
    50: '#fffbeb',
    100: '#fef3c7',
    200: '#fde68a',
    300: '#fcd34d',
    400: '#fbbf24',
    500: '#f59e0b',
    600: '#d97706',
    700: '#b45309',
    800: '#92400e',
    900: '#78350f',
  },
  error: {
    50: '#fef2f2',
    100: '#fee2e2',
    200: '#fecaca',
    300: '#fca5a5',
    400: '#f87171',
    500: '#dc2626',
    600: '#b91c1c',
    700: '#991b1b',
    800: '#7f1d1d',
    900: '#450a0a',
  },
  neutral: {
    50: '#f7f8fa',
    100: '#eef1f5',
    200: '#dde3eb',
    300: '#c5ced9',
    400: '#9aa8b8',
    500: '#6b7a8c',
    600: '#4f5d6e',
    700: '#3a4654',
    800: '#252e3a',
    900: '#141a22',
  },
};

/** Locked brand theme — only `vlsi` is used by ThemeProvider. */
export const colorSchemes = {
  vlsi: {
    name: 'VLSI Expert',
    brand: 'VLSI Expert Pvt. Ltd.',
    colors: vlsiColors,
  },
};

export const BRAND_THEME_ID = 'vlsi';
export const BRAND_NAME = 'VLSI Expert Pvt. Ltd.';
export const PRODUCT_NAME = 'VLSI Student Management System';
